var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLoveItHandGive = function SvgLoveItHandGive(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none!important",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.652 5.235a2.45 2.45 0 0 0-3.926-.637l-.208.209a.175.175 0 0 1-.246 0l-.212-.212a2.452 2.452 0 0 0-3.473 3.462l3.316 3.459a.677.677 0 0 0 .983 0l3.31-3.454a2.449 2.449 0 0 0 .456-2.827zm-15.04 8.206a.696.696 0 0 0-.695.696v5.042a.695.695 0 0 0 1.39 0v-5.042a.695.695 0 0 0-.695-.696zm3.738 3.304h6.346a.695.695 0 0 1 .695.695v.184a1.557 1.557 0 0 1-1.555 1.555H6.351a.348.348 0 0 1-.348-.348v-4.52a.348.348 0 0 1 .348-.348h2.965a1.555 1.555 0 0 1 1.43.944.695.695 0 0 1-.64.969H8.35a.434.434 0 1 0 0 .869z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLoveItHandGive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "love-it-hand-give.d34065987ee00d3da33520fa639044a2.svg";